<div app-sidenav class="flex items-center flex-col gap-4 overflow-y-auto">
  <app-shortcut-list class="w-full" />
  <app-shortcut-button class="w-full" />
  <app-shortcut-systematic-list *isAllow="[20, 89]" class="w-full" />
</div>
